module.exports = __webpack_public_path__ + "img/2.4f69f6b3.jpg";